export default {
  settings: {
    title: "Settings",
    subtitle: "Manage your account and preferences",
    nav: {
      profile: "Profile & Couple",
      wedding: "Wedding Details",
      event: "Event Details",
      collaborators: "Collaborators",
      notifications: "Notifications",
      appearance: "Appearance & Language",
      subscription: "Subscription",
      security: "Security"
    },
    groups: {
      account: "Account",
      event: "Event",
      preferences: "Preferences"
    },
    general: {
      title: "Profile & Couple",
      description: "Manage your personal information and your partner's.",
      me: "Me",
      partner: "My Partner",
      partnerHelp: "Invite your partner to join the wedding management."
    },
    wedding: {
      title: "Wedding Details",
      description: "Essential information about your event."
    },
    appearance: {
      title: "Appearance & Language",
      description: "Customize your experience.",
      languages: {
        fr: "French",
        en: "English",
        es: "Spanish",
        de: "German",
        it: "Italian"
      }
    },
    notifications: {
      email: {
        title: "Email Notifications",
        description: "Receive important updates and reminders by email"
      },
      push: {
        title: "Push Notifications",
        description: "Receive real-time alerts on your browser"
      },
      title: "Notifications",
      description: "Choose how and when you want to be notified.",
      enable: "Enable notifications",
      enableDesc: "Receive alerts for important events",
      types: "Notification types",
      reminderTiming: "Default reminder timing",
      hoursBefore: "{{count}}h before",
      quietHours: "Quiet hours",
      start: "Start",
      end: "End",
      labels: {
        tasks: "Tasks",
        guests: "Guests",
        budget: "Budget",
        system: "System"
      },
      error: "Error loading notification settings"
    },
    security: {
      title: "Security",
      description: "Manage your password and sessions.",
      status: "Account Status",
      verified: "Your email is verified.",
      unverified: "Your email is not verified.",
      sessions: "Active Sessions",
      dangerZone: "Danger Zone",
      deleteAccount: "Delete Account",
      deleteAccountHelp: "This action cannot be undone."
    },
    collaborators: {
      title: "Sharing Management",
      invitationsTitle: "Sharing Invitations",
      noWedding: "No wedding found",
      loadError: "An error occurred while loading the wedding",
      invitationsError: "An error occurred while loading invitations",
      noInvitations: "No invitations found",
      noInvitationsDesc: "Sharing invitations will appear here once created",
      expiresAt: "Expires on: {{date}}",
      accessCode: "Access code: {{code}}",
      infoMessage: "This page displays sent sharing invitations. To create new invitations or manage collaborators, use the ShareManagement component in your event settings.",
      status: {
        pending: "Pending",
        accepted: "Accepted",
        declined: "Declined",
        expired: "Expired"
      },
      resourceTypes: {
        tasks: "Tasks",
        guests: "Guests",
        budget: "Budget",
        timeline: "Timeline",
        tasksAndGuests: "Tasks and Guests"
      }
    },
    subscription: {
      title: "Subscription & Billing",
      description: "Manage your plan and track your usage.",
      invoices: "Invoices",
      noInvoices: "No invoices available",
      upgrade: "Upgrade to Premium",
      features: {
        oneEvent: "1 Event",
        basicGuests: "Basic Guest List",
        limitedTasks: "Limited Tasks",
        unlimitedEvents: "Unlimited Events",
        unlimitedGuests: "Unlimited Guests",
        export: "PDF & Excel Export",
        seating: "Advanced Seating Plan",
        budget: "Budget & Analytics",
        support: "Priority Support"
      },
      proDescription: "Enjoy all features without limits.",
      freeDescription: "Upgrade to Premium to unlock all features."
    },
    theme: "Theme",
    placeholders: {
      exampleName: "Ex: Mary Smith",
      exampleVenue: "Ex: Grand Hotel"
    },
    language: "Language",
    languageDescription: "Choose the interface language",
    account: {
      export: {
        button: "Export my data",
        loading: "Exporting..."
      },
      errors: {
        exportData: "Error exporting data",
        deleteAccount: "Error deleting account"
      }
    },
    export: {
      title: "Export my data",
      description: "Download a copy of all your data (guests, tasks, budget, etc.)",
      gdprNotice: "In accordance with GDPR, you can retrieve all your personal data."
    },
    delete: {
      title: "Delete my account",
      description: "This action is irreversible. All your data will be permanently deleted.",
      confirmTitle: "Delete my account?",
      confirmDescription: "Are you sure you want to permanently delete your account? All your data will be lost.",
      confirmButton: "Delete permanently"
    },
    firstName: "First Name",
    lastName: "Last Name",
    email: "Email",
    partnerName: "Full Name",
    partnerEmail: "Email (for invitation)",
    weddingDate: "Wedding Date",
    location: "Venue & Location",
    venue: "Reception Venue",
    country: "Country",
    city: "City",
    guestCount: "Estimated Guest Count",
    password: "Password",
    passwordHelp: "Last changed 3 months ago",
    changePassword: "Change",
    currentPassword: "Current Password",
    newPassword: "New Password"
  }
};